import React, { useState } from "react";
import PropTypes from "prop-types";

import { VerticalTimeline } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import TimelineItem from "components/Timeline/TimelineItem";

import TimelineDetailDialog from "./TimelineDetailDialog";

const TimelineComponent = (props) => {
  const [showDetail, setShowDetail] = React.useState(false);
  const [timelineSelected, setTimelineSelected] = useState(null);
  const handleShowDetail = React.useCallback((timeline) => {
    setShowDetail(true);
    setTimelineSelected(timeline);
  }, []);
  const handleHideDetail = React.useCallback((timeline) => {
    setShowDetail(false);
    setTimelineSelected(null);
  }, []);
  const { timelines = [] } = props;

  return (
    <VerticalTimeline>
      {timelines.map((timeline, idx) => {
        const key = `${idx}${timeline.companyName}`;
        return (
          <TimelineItem onShowDetail={(tl) => handleShowDetail(tl)} key={key} timeline={timeline} />
        );
      })}
      <TimelineDetailDialog show={showDetail} onHide={handleHideDetail} {...timelineSelected} />
    </VerticalTimeline>
  );
};

TimelineComponent.propTypes = {
  timelines: PropTypes.array.isRequired,
};

export default TimelineComponent;
